import produce from 'immer';
import { AnyAction } from 'redux';
import {
  SET_HOORY_WIDGET_HIDERS_COUNT,
  SET_TERMINAL_ACCOUNT_MOUNTED
} from 'appRedux/ActionTypes';

type InitialStateType = {
  terminalAccountMounted: boolean;
  hooryWidgetHidersCount: {
    modal: number;
    drawer: number;
    confirmPopup: number;
  };
};

export const INIT_STATE: InitialStateType = {
  terminalAccountMounted: false,
  hooryWidgetHidersCount: {
    modal: 0,
    drawer: 0,
    confirmPopup: 0
  }
};

export const GlobalReducer = (
  state = INIT_STATE,
  action: AnyAction
): InitialStateType =>
  produce(state, draft => {
    switch (action.type) {
      case SET_TERMINAL_ACCOUNT_MOUNTED:
        draft.terminalAccountMounted = action.payload;
        break;
      case SET_HOORY_WIDGET_HIDERS_COUNT: {
        const hiderType = action.payload
          .hiderType as keyof InitialStateType['hooryWidgetHidersCount'];
        draft.hooryWidgetHidersCount[hiderType] =
          action.payload.operation === 'increase'
            ? draft.hooryWidgetHidersCount[hiderType] + 1
            : draft.hooryWidgetHidersCount[hiderType] - 1;
        break;
      }
      default:
        break;
    }
  });
